export default {
  operationRecord: {
    title: "History",
    totalData: "records",
    totalPrefix: "Total",
    onlyKeyStep: "Show key steps only",
  },
  historyRecode: {
    loading: "Loading...",
    headers: {
      name: "Name",
      updateTime: "Update Time",
      operation: "Operation",
    },
    empty: "No data",
    more: "More",
    messages: {
      deleteConfirm:
        "This operation will permanently delete the file. Continue?",
      deleteConfirmTitle: "Confirm",
      confirmButton: "Confirm",
      cancelButton: "Cancel",
      cancelKeyStep: "Key step cancelled!",
      addKeyStep: "Added to key steps!",
      editSuccess: "Modified successfully",
      deleteSuccess: "Deleted successfully",
      cancelDelete: "Deletion cancelled",
    },
  },
};
